module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', _vm._l((_vm.meetups), function(meetup) {
    return _c('v-layout', {
      key: meetup.id,
      staticClass: "mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "md8": "",
        "offset-sm1": "",
        "offset-md2": ""
      }
    }, [_c('v-card', {
      staticClass: "info"
    }, [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": "",
        "sm4": "",
        "md3": ""
      }
    }, [_c('v-card-media', {
      attrs: {
        "src": meetup.imageUrl,
        "height": "130px"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": "",
        "sm8": "",
        "md9": ""
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [_c('h5', {
      staticClass: "white--text mb-0"
    }, [_vm._v(_vm._s(meetup.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(meetup.date))])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "to": '/meetups/' + meetup.id
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "light": ""
      }
    }, [_vm._v("arrow_forward")]), _vm._v("\n                  View Meetup\n                ")], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3358c3ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Meetup/Meetups.vue
// module id = 49
// module chunks = 1